<template>
    <div class="row" data-test-view="skills-matrix">
        <div class="col-md-12">
            <l-card-content>
                <l-headline :title="$t('skills.title')" :tabs="tabs"> </l-headline>

                <div class="row">
                    <div class="col-md-3">
                        <l-select
                            v-model="teamFilter"
                            wrapper-class="dropdown"
                            :options="[
                                { value: ``, text: $t(`skills.selectTeam`) },
                                ...localTeams.map(team => ({ value: team._id, text: team.name })),
                            ]"
                        />
                    </div>
                    <div class="col-md-3">
                        <l-select
                            v-model="comparator"
                            wrapper-class="dropdown"
                            :options="[
                                {
                                    value: 'order',
                                    text: $t('skills.option-sortByDefault'),
                                },
                                {
                                    value: 'categoryName',
                                    text: $t('skills.option-sortByCategory'),
                                },
                                {
                                    value: 'type',
                                    text: $t('skills.option-sortByType'),
                                },
                            ]"
                        />
                    </div>
                </div>

                <l-skill-matrix
                    :matrix="sortedMatrix"
                    :custom-roles="customRoles"
                    :admin-mode="false"
                >
                </l-skill-matrix>
            </l-card-content>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import orderBy from "lodash.orderby";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LSelect from "@/components/LSelect";
import LSkillMatrix from "@/components/LSkillMatrix";

export default {
    components: {
        LCardContent,
        LHeadline,
        LSelect,
        LSkillMatrix,
    },
    data() {
        return {
            error: false,
            comparator: "type",
            teamFilter: "",
            matrix: [],
            customRoles: [],
        };
    },
    computed: {
        ...mapGetters({
            getMatrix: "skills/getMatrix",
            getCustomRoles: "skills/getCustomRoles",
            localTeams: "teams/local/listSortedByName",
        }),
        sortedMatrix: function() {
            var matrix = this.getMatrix();

            // filter

            if (this.teamFilter != "") {
                matrix = matrix.filter(
                    s => s.type == "team" || s.localTeam.some(l => l._id == this.teamFilter),
                );
            } else {
                matrix = matrix.filter(s => s.showByDefault);
            }

            return orderBy(matrix, this.comparator);
        },
        tabs: function() {
            return [
                {
                    label: this.$t("skills.labelMatrix"),
                    show: true,
                    active: true,
                },
            ];
        },
    },
    watch: {
        teamFilter: {
            handler(team) {
                this.comparator = "type";

                if (team != "") {
                    this.customRoles = this.getCustomRoles().filter(
                        customRole =>
                            !customRole.localTeams ||
                            !customRole.localTeams.length ||
                            customRole.localTeams.some(localTeam => localTeam == team),
                    );
                } else {
                    this.customRoles = this.getCustomRoles().filter(
                        customRole => customRole.showDefault,
                    );
                }
            },
        },
    },
    created() {
        this.customRoles = this.getCustomRoles().filter(customRole => customRole.showByDefault);
    },
};
</script>

<style scoped></style>
